import List from "@/components/list";

const Table = args => {
  const { listeners, props } = args;
  const RCSelectionChange = args.listeners["selection-change"] || function () { };
  const handleInfo = listeners["handleInfo"] || function () { };
  const handleEdit = listeners["handleEdit"] || function () { };
  const dealDelete = listeners["dealDelete"] || function () { };
  const setDown = listeners["setDown"] || function () { };
  const handleShare = listeners["handleShare"] || function () { };

  const deptLevelCode = args.props.deptLevelCode;

  const Deal = ({ props: { vo } }) => {
    let dealConf = [];
    // 小程序特色内容
    let isMyCollege = vo.row.originDeptLevelCode == deptLevelCode;
    if (isMyCollege && vo.row.onlineStatus == 0) {
      // 版权方为本学院 && 下线状态
      dealConf.push(["icon-edit", "编辑", () => handleEdit(vo.row), "clientIndexConfig:save"]);
    } else {
      dealConf.push(["icon-edit-disable", "编辑", () => { }, "clientIndexConfig:save"]);
    }
    if (vo.row.onlineStatus == 0) {
      // 下线状态
      dealConf.push(["icon-delete", "删除", () => dealDelete(vo.row), "clientIndexConfig:delete"]);
      dealConf.push(["icon-up", "上线", () => setDown(vo.row.uuid, 1), "clientIndexConfig:updateOnlineStatus"]);
    } else {
      dealConf.push(["icon-delete-disable", "删除", () => { }, "clientIndexConfig:delete"]);
      dealConf.push(["icon-down", "下线", () => setDown(vo.row.uuid, 0), "clientIndexConfig:updateOnlineStatus"]);
    }
    if (isMyCollege) {
      dealConf.push(["icon-share", "共享管理", () => handleShare(vo.row), "clientIndexConfig:share"]);
    } else {
      dealConf.push(["icon-share-none", "共享管理", () => { }, "clientIndexConfig:share"]);
    }

    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const Img = ({ props: { vo } }) => {
    let url = vo.row.coverUrl;
    return (
      <div >
        <el-image
          style="width: 160px; height: 90px; cursor: pointer"
          src={url}
          fit={'contain'}
          lazy
          preview-src-list={[url]}
        ></el-image>
      </div>
    );
  };

  const NameComp = ({ props: { vo } }) => {
    const item = vo.row;
    return (
      <div class="base-hover-char" onClick={() => handleInfo(item)}>
        {item.name}
      </div>
    );
  };

  let AccountTableConfig = [
    {
      type: "selection",
      label: "main",
    },
    {
      label: "名称",
      prop: "name",
      showOverflowTooltip: true,
      render: vo => <NameComp vo={vo} />
    },
    {
      label: "icon图片",
      width: "200",
      render: vo => <Img vo={vo} />
    },
    {
      label: "跳转类型",
      prop: "skipTypeStr"
    },
    {
      label: "状态",
      width: "100",
      prop: "onlineStatusStr"
    },
    {
      label: "版权方",
      prop: "originDeptName"
    },
    {
      label: "已共享学院",
      prop: "sharedDeptNames"
    },
    {
      label: "操作",
      fixed: "right",
      width: '200',
      render: vo => <Deal vo={vo} />
    }
  ];

  return (
    <div>
      <List
        {...args}
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
